import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { Currency } from "@front/m19-api-client";
import { UserSelectionService } from "@front/m19-services";
import { ISelectMenuImports, Option } from "@front/m19-ui";
import { UntilDestroy } from "@ngneat/until-destroy";
import { toSignal } from "@angular/core/rxjs-interop";
import { CurrencySymbols } from "@front/m19-models";

@UntilDestroy()
@Component({
  selector: "app-currency-selection",
  templateUrl: "./currency-selection.component.html",
  imports: [ISelectMenuImports],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencySelectionComponent {
  private readonly userSelectionService = inject(UserSelectionService);

  private readonly selectedCurrency = toSignal(this.userSelectionService.selectedCurrency$, { requireSync: true });

  private readonly currencies: { label: string; value: Currency }[] = (Object.keys(Currency) as Currency[]).map(
    (c: Currency) => ({
      label: CurrencySymbols[c],
      value: c,
    }),
  );

  protected readonly searchQuery = signal<string>("");

  protected filteredCurrencies = computed(() =>
    this.currencies.filter(
      (c) =>
        c.label.toLowerCase().includes(this.searchQuery().toLowerCase()) ||
        c.value.toLowerCase().includes(this.searchQuery().toLowerCase()),
    ),
  );

  protected readonly selectedCurrencyOption = computed(() =>
    this.currencies.find((c) => c.value === this.selectedCurrency()),
  );

  protected changeCurrency(currency: Option<Currency> | undefined) {
    if (!currency) return;
    this.userSelectionService.setCurrency(currency.value);
  }
}
